import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes/index';
import store from '@/store';
import { i18n } from '@/i18n';
import ManuteAuth from '@/api/src/auth';
import ManuteAuthToken from '@/api/src/token';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to, from, next) => {
    // Check if auth is initialized
    if (! store.state.appLoaded) {
        await store.dispatch('initApp');
        // Init language.
        i18n.locale = store.getters.getPreferenceByKey('language') || 'it';
    }

    const tenantIdentified = store.getters.tenantIdentified;

    // If user is logged in will be redirected to the dashboard.
    if (to.matched.some((record) => !record.meta.noTenant) && !tenantIdentified) {
        // redirect to error page
        return next({ name: 'no-tenant' });
    }

    // If user is logged in will be redirected to the dashboard.
    if (to.matched.some((record) => record.meta.noTenant) && tenantIdentified) {
        // redirect to error page
        return next({ name: 'home' });
    }

    let isAuth = false;
    try {
        // Get auth token
        let token = ManuteAuthToken.fromStorage();
        // Check if the token is expired.
        if (token.isExpired) {
            token = await ManuteAuth.refreshToken();
        }
        isAuth = token.isValid;
    } catch (e) {
        isAuth = false;
    }

    // Check if the route requires authentication and user is not logged in.
    if (to.matched.some((record) => record.meta.auth) && !isAuth) {
        // redirect to login page
        return next({ name: 'login' });
    }

    // If user is logged in will be redirected to the dashboard.
    if (to.matched.some((record) => record.meta.guest) && isAuth) {
        // redirect to dashboard page
        return next({ name: 'home' });
    }

    // Continue.
    next();
});

export default router;
